import { resolve } from './tokens.js';

/*
 * Dots
 *
 * The animated "working on it" indicator, in one place.
 *
 * IT CARRIES ITS OWN KEYFRAMES. They used to live inside the message renderer,
 * which meant anything else drawing the same dots got three motionless circles:
 * the animation name resolved to a rule that was not on the page, and CSS says
 * nothing when you name an animation that does not exist. Bundling the style
 * tag with the component makes that impossible, and copying this folder into
 * another app cannot leave the animation behind.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const KEYFRAMES = `
@keyframes graci-bounce {
    0%, 60%, 100% { opacity: 0.35; transform: translateY(0); }
    30% { opacity: 1; transform: translateY(-3px); }
}
@media (prefers-reduced-motion: reduce) {
    @keyframes graci-bounce { 0%, 100% { opacity: 0.6; transform: none; } }
}`;
const Dots = ({
  label,
  tone,
  tokens: raw
}) => {
  const tokens = resolve(raw);
  return /*#__PURE__*/_jsxs("span", {
    "aria-label": label || 'Working',
    role: 'status',
    style: {
      alignItems: 'center',
      backgroundColor: tone === 'accent' ? tokens.accent : tokens.muted,
      borderRadius: 25,
      display: 'inline-flex',
      gap: 5,
      padding: '12px 16px 12px 16px'
    },
    children: [/*#__PURE__*/_jsx("style", {
      children: KEYFRAMES
    }), [0, 1, 2].map(index => /*#__PURE__*/_jsx("span", {
      style: {
        animation: `graci-bounce 1.2s ${index * 0.16}s infinite ease-in-out`,
        backgroundColor: 'white',
        borderRadius: 999,
        display: 'inline-block',
        height: 7,
        width: 7
      }
    }, index))]
  });
};
export default Dots;